import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Lenis from "lenis";

const prefersReduced = () =>
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

const ScrollManager = () => {
    const { pathname, hash } = useLocation();

    useEffect(() => {
        if (prefersReduced()) return undefined;
        const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
        window.__lenis = lenis;
        let raf;
        const loop = (t) => {
            lenis.raf(t);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    useEffect(() => {
        if (hash) {
            const t = setTimeout(() => {
                if (window.__lenis)
                    window.__lenis.scrollTo(hash, { duration: 1.2 });
                else
                    document
                        .querySelector(hash)
                        ?.scrollIntoView({ behavior: "smooth" });
            }, 150);
            return () => clearTimeout(t);
        }
        if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
        else window.scrollTo(0, 0);
    }, [pathname, hash]);

    return null;
};

export default ScrollManager;
